import R from 'ramda'
import {defineMessages} from 'react-intl'

import fetchServices from '../api/fetchServices'

import addNotification from './addNotification'

const serviceToServiceKey = service => `${service.name} ${service.coordinates.lat} ${service.coordinates.lng}`

const messages = defineMessages({
  title: {
    id: 'An error happend', 
    defaultMessage: 'An error happened'
  },
  message: {
    id: "This list of services could not be retrieved, try again later", 
    defaultMessage: "This list of services could not be retrieved, try again later"
  }
})

const notification = {type: "error", message: messages.message, title: messages.title}

const onComplete = dispatch => (err, services) => {
  if(err){
    dispatch(addNotification(notification))    
    return console.error("Failed to fetch services", err)
  }
  dispatch({type: 'load_services', services})
}

export default _ => (dispatch, getState) => {
  const state = getState()
  const servicesIds = state.serviceIds
  const viewPort = state.viewPort
  if(R.isEmpty(servicesIds)){ return onComplete(dispatch)(null, []) }  
  fetchServices(viewPort, servicesIds, onComplete(dispatch))
}




/** WEBPACK FOOTER **
 ** ./app/actions/fetchServices.js
 **/